import {createUseStyles} from 'react-jss'
import Modal from '../Modal'
import InputField from '../InputField'
import Switch from '../Switch'
import {useTranslation} from 'react-i18next'
import {EmployeeEditor} from "./useEmployeeEditor";

interface Props {
  editor: EmployeeEditor
  onSaveClick?: () => void
  onCancelClick?: () => void
  visible: boolean
}

const EditPayoutLimitationsModal = ({
                             editor,
                             onSaveClick,
                             onCancelClick,
                             visible
                           }: Props) => {
  const styles = useStyles()
  const {t} = useTranslation(['common', 'employees']);

  const handleOnSave = () => {
    onSaveClick && onSaveClick()
  }

  const handleOnCancel = () => {
    onCancelClick && onCancelClick()
  }

  return (
    <Modal
      title={t('payoutLimitations', {ns: 'employees'})}
      visible={visible}
      okButtonTitle={t('save', {ns: 'common'})}
      cancelButtonTitle={t('cancel', {ns: 'common'})}
      onHide={() => handleOnCancel()}
      onOkClick={() => handleOnSave()}
      onCancelClick={() => handleOnCancel()}
      okButtonDisabled={!editor.isValid}
    >
      <div className={styles.sectionRow}>
        <p>{t('payoutLimitationDescription', {ns: 'employees'})}</p>
        <div className={styles.row}>
          <Switch
            id='displayPayoutLimitationInfo'
            key='displayPayoutLimitationInfo'
            checked={editor.employee.displayPayoutLimitationInfo}
            label={t('displayPayoutLimitationInfo', {ns: 'employees'})}
            onChange={value => editor.handleChange('displayPayoutLimitationInfo', !editor.employee.displayPayoutLimitationInfo)}
            tooltipText={t('displayPayoutLimitationInfoDescription', {ns: 'employees'})}
          />
        </div>
        <div className={styles.row}>
          <InputField
            type='number'
            id='maxAmountPerPayday'
            valid={editor.valid.maxAmountValid}
            value={editor.employee.payoutSettings.maxAmountPerPayday?.toString() ?? ''}
            onChange={value => editor.handlePayoutSettingsChange('maxAmountPerPayday', value)}
            label={t('maxAmountPerPayday', {ns: 'employees'})}
            placeholder=''
            tooltipText={t('maxAmountPerPaydayDescription', {ns: 'employees'})}
          />
        </div>
        <div className={styles.row}>
          <InputField
            type='number'
            id='maxPercentagePerPayday'
            valid={editor.valid.maxPercentageValid}
            value={editor.employee.payoutSettings.maxPercentagePerPayday?.toString() ?? ''}
            onChange={value => {
              editor.handlePayoutSettingsChange('maxPercentagePerPayday', value)
            }}
            label={t('maxPercentagePerPayday', {ns: 'employees'})}
            placeholder=''
            tooltipText={t('maxPercentagePerPaydayDescription', {ns: 'employees'})}
          />
        </div>
        <div className={styles.row}>
          <InputField
            type='number'
            id='maxCustomPercentagePerPayday'
            valid={editor.valid.maxCustomPercentageValid}
            value={editor.employee.payoutSettings.maxCustomPercentagePerPayday?.toString() ?? ''}
            onChange={value => {
              editor.handlePayoutSettingsChange('maxCustomPercentagePerPayday', value)
            }}
            label={t('maxCustomPercentagePerPayday', {ns: 'employees'})}
            placeholder=''
            tooltipText={t('maxCustomPercentagePerPaydayDescription', {ns: 'employees'})}
          />
        </div>
        <div className={styles.row}>
          <InputField
            id='payoutLimitationReason'
            value={editor.employee.payoutLimitationReason?.toString() ?? ''}
            onChange={value => {
              editor.handleChange('payoutLimitationReason', value)
            }}
            label={t('payoutLimitationReason', {ns: 'employees'})}
            placeholder=''
            tooltipText={t('payoutLimitationReasonDescription', {ns: 'employees'})}
          />
        </div>
      </div>
    </Modal>
  )
}

export default EditPayoutLimitationsModal

const useStyles = createUseStyles({
  row: {
    paddingBottom: 12
  },
  sectionTitle: {
    marginBottom: 15
  },
  sectionRow: {
    paddingBottom: 25
  }
})
